// extracted by mini-css-extract-plugin
module.exports = {"appliedButton":"appliedButton"};